import { useTranslation } from "react-i18next";
import WarningRed from "../../../assets/icons/red-warning.svg";
import "./ScriptAlreadySent.less";

const ScriptAlreadySent: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="script-already-sent-container">
      <img src={WarningRed} width={10} height={10} alt="warning" />
      <p className="script-already-sent-text">{t("already-sent")}</p>
    </div>
  );
};

export default ScriptAlreadySent;
